import * as React from "react";

import ReploBuilder from "@svg/billing/ReploBuilder";

import { Progress } from "@replo/design-system/components/progress/Progress";
import { format } from "date-fns";

import MetricBox from "./MetricBox";
import ProductCard from "./ProductCard";
import UsageRow from "./UsageRow";

type ReploSitesUsageSummaryCardProps = {
  currentSites: number;
  maximumSites: number | null;
  currentChatMessages: number;
  maximumChatMessages: number | null;
  nextChatResetDate?: Date;
  showChatMessages?: boolean;
};

const ReploSitesUsageSummaryCard = ({
  currentSites,
  maximumSites,
  currentChatMessages,
  maximumChatMessages,
  nextChatResetDate,
  showChatMessages = true,
}: ReploSitesUsageSummaryCardProps) => {
  return (
    <ProductCard icon={<ReploBuilder />} title="Replo Sites">
      <UsageRow
        title="Active Sites"
        description="Replo Sites count as active once you connect a custom domain."
      >
        <MetricBox
          label="Active Sites"
          current={currentSites}
          maximum={maximumSites}
          // TODO (Andrew, 2026-01-30, REPL-18539): Add back when plan change modal is added
          // buttonLabel={modifiableTier ? "Add Sites" : undefined}
          // onButtonClick={modifiableTier ? handleAddSites : undefined}
        />
      </UsageRow>
      {showChatMessages && (
        <UsageRow
          title="Messages Used"
          description={
            nextChatResetDate
              ? `Resets on ${format(nextChatResetDate, "MMM d, yyyy")}`
              : "Monthly chat message allocation."
          }
          hasBorderBottom={false}
        >
          <MetricBox
            label="Chat Messages"
            current={currentChatMessages}
            maximum={maximumChatMessages}
          >
            {maximumChatMessages !== null && (
              <Progress
                value={currentChatMessages}
                max={maximumChatMessages ?? currentChatMessages}
                UNSAFE_indicatorClassName="bg-gradient-to-r from-black to-[#EF196E] rounded-full"
              />
            )}
          </MetricBox>
        </UsageRow>
      )}
    </ProductCard>
  );
};

export default ReploSitesUsageSummaryCard;
